<div class="filter-header">
  <app-date-range-select
    class="date-range-select"
    [useQueryParam]="'range'"
    [chips]="(dateRangeChips$ | async) || []">
  </app-date-range-select>
  <button
    [class.outline-pill-button]="filterCollapsed$ | async"
    [class.secondary-pill-button]="!(filterCollapsed$ | async)"
    (click)="filterCollapsed$.next(!filterCollapsed$.value)"
    data-cy="availability-management-collapse-filter-button"
    type="button">
    <mat-icon [svgIcon]="'filter-alt'"></mat-icon>
    <span class="mat-fab__label">{{ ("filter" | i18n) || "Filter" }}</span>
    <span
      *ngIf="filterCount$ | async as count"
      class="filter-count-badge"
      [class.active-filter-badge]="!(filterCollapsed$ | async)">
      {{ count }}
    </span>
  </button>
</div>
<div
  class="collapse-wrapper collapse-filter"
  [class.collapsed]="filterCollapsed$ | async">
  <div class="collapse-child">
    <div></div>
    <div class="row">
      <app-department-select
        class="col-md-4"
        [autoSelectOnlyDepartment]="true"
        [useQueryParam]="'department'"></app-department-select>
      <app-certificate-select
        class="col-6 col-md-4"
        [useQueryParam]="'certificates'"></app-certificate-select>
      <app-speciality-select
        class="col-6 col-md-4"
        [useQueryParam]="'specialities'">
      </app-speciality-select>
    </div>
    <div class="row">
      <app-customer-select
        *ngIf="hasAgencies$ | async"
        class="col-6 col-md-3"
        [useQueryParam]="'restrictToCustomerIds'">
      </app-customer-select>
      <app-text-search
        class="col-6 col-md-9"
        [useQueryParam]="'search'"></app-text-search>
    </div>
    <div class="flex">
      <button
        *ngIf="!(loggedInCustomer$ | async)?.disableDispoFilterSave"
        mat-button
        class="save-filter-button"
        (click)="saveDefaultFilter()"
        data-cy="save-filter-button">
        {{ ("saveDefaultFilter" | i18n) || "Filter als Standard speichern" }}
      </button>
    </div>
  </div>
</div>
